import { graphql } from '@repo/common/queries/schemas/server_user_query'

export const query_get_kyc_access_token = graphql(`
  query get_kyc_access_token(
    $level: KycAccessLevel!
    $applicant_type: KycApplicant!
  ) {
    me {
      kyc {
        access_token(level: $level, applicant_type: $applicant_type)
      }
    }
  }
`)

export const query_get_kyc_status = graphql(`
  query get_kyc_status {
    me {
      kyc {
        verification {
          passed
          level
          status
          market
          applicant_type
        }
      }
    }
  }
`)
